module.exports = __webpack_public_path__ + "img/mod_2.40d64eb1.jpg";